/**
 * Decorative dashboard graphic for the "ERP خودم رو می‌خوام بسازم" card on
 * `StartPage` — the same panel as `DemoDashboardIllustration`, but with the
 * KPI numbers and lists cleared out, to read as "this becomes yours, empty,
 * ready for your own data" rather than a second copy of the demo. Purely
 * presentational — no real data. Colors come from the `--sk-*` v2 design
 * tokens so it stays correct in both themes without its own palette.
 */
export function BuildWorkspaceIllustration() {
  return (
    <svg
      viewBox="0 0 380 236"
      width="100%"
      height="220"
      role="img"
      aria-label="پیش‌نمایش فضای کاری خالی، آماده برای داده‌های واقعی شما"
      style={{ display: 'block', overflow: 'visible' }}
    >
      <defs>
        <linearGradient id="sk-build-illu-back" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="var(--sk-brand-700)" />
          <stop offset="1" stopColor="var(--sk-brand-900)" />
        </linearGradient>
        <filter id="sk-build-illu-shadow-front" x="-30%" y="-30%" width="160%" height="160%">
          <feDropShadow
            dx="0"
            dy="14"
            stdDeviation="16"
            floodColor="var(--sk-brand-900)"
            floodOpacity="0.2"
          />
        </filter>
        <filter id="sk-build-illu-shadow-back" x="-30%" y="-30%" width="160%" height="160%">
          <feDropShadow
            dx="0"
            dy="10"
            stdDeviation="12"
            floodColor="var(--sk-fg)"
            floodOpacity="0.16"
          />
        </filter>
      </defs>

      <g filter="url(#sk-build-illu-shadow-back)">
        <rect x="228" y="10" width="126" height="196" rx="22" fill="url(#sk-build-illu-back)" />
        <rect x="250" y="30" width="46" height="30" rx="8" fill="var(--sk-brand-400)" />
        <rect x="250" y="72" width="82" height="8" rx="4" fill="rgba(255,255,255,0.14)" />
        <rect x="250" y="88" width="60" height="8" rx="4" fill="rgba(255,255,255,0.10)" />
        <rect x="250" y="104" width="70" height="8" rx="4" fill="rgba(255,255,255,0.10)" />
      </g>

      <g filter="url(#sk-build-illu-shadow-front)">
        <rect
          x="4"
          y="32"
          width="300"
          height="196"
          rx="20"
          fill="var(--sk-bg-elev)"
          stroke="var(--sk-border)"
        />
        <circle cx="24" cy="52" r="4" fill="var(--sk-danger)" />
        <circle cx="38" cy="52" r="4" fill="var(--sk-warn)" />
        <circle cx="52" cy="52" r="4" fill="var(--sk-success)" />
        <line x1="24" y1="66" x2="284" y2="66" stroke="var(--sk-divider)" />

        <rect x="24" y="80" width="78" height="36" rx="10" fill="var(--sk-bg-canvas)" />
        <text x="63" y="102" textAnchor="middle" fontSize="16" fill="var(--sk-fg-subtle)">
          —
        </text>
        <rect x="112" y="80" width="86" height="36" rx="10" fill="var(--sk-bg-canvas)" />
        <text x="155" y="102" textAnchor="middle" fontSize="16" fill="var(--sk-fg-subtle)">
          —
        </text>
        <rect x="208" y="80" width="76" height="36" rx="10" fill="var(--sk-bg-canvas)" />
        <text x="246" y="102" textAnchor="middle" fontSize="16" fill="var(--sk-fg-subtle)">
          —
        </text>

        <rect
          x="24"
          y="128"
          width="260"
          height="86"
          rx="12"
          fill="var(--sk-bg-sunken)"
          stroke="var(--sk-border-strong)"
          strokeDasharray="4 4"
        />
        <text
          x="154"
          y="176"
          textAnchor="middle"
          fontSize="12"
          fontWeight="600"
          fill="var(--sk-fg-subtle)"
        >
          هنوز داده‌ای ثبت نشده
        </text>
      </g>
    </svg>
  );
}
